// eslint-disable-next-line import/no-anonymous-default-export
export default {
    AUTH_REDUCER: 'AUTH_REDUCER',
    CLEAR_AUTH_REDUCER: 'CLEAR_AUTH_REDUCER',
    USER_REDUCER: 'USER_REDUCER',
}